/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';

import { EditWrapperComponent } from './components/edit-wrapper/edit-wrapper.component';

@Injectable()
export class TicketEditServiceTemplater {
	public editWrapperComponent: EditWrapperComponent; //to change the templates programatically

	private _lastLoadedComponent;
	public get lastLoadedComponent() {
		return this._lastLoadedComponent;
	}

	constructor() {}

	public registerEditWrapper(editWrapperComponent: EditWrapperComponent) {
		if (this.editWrapperComponent) {
			//do some cleanup
		}
		this.editWrapperComponent = editWrapperComponent;
	}

	//all of this is exceptionally placeholder-y
	public openEdit(selectedComponent) {
		// this.editWrapperComponent.changeChildComponent(selectedComponent);
		this._lastLoadedComponent = selectedComponent;
	}
	public closeEdit() {
		// this.editWrapperComponent.clearChildComponent();
		this._lastLoadedComponent = null;
	}
}
